<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="item ? (showConsumables ? ('Update Item' | translate) : ('Update Asset' | translate)) : (showConsumables ? ('Add Item' | translate) : ('Add Asset' | translate))"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>
      @if (loaded) {

        <tidy-card>
          <tidy-row class="extra-bottom-padding vertical-align-center">
            <tidy-image
              [src]="'assets/img/information.svg'"
              class="header-size" />
            <tidy-text
              [header]="showConsumables ? 'Item Details' : 'Asset Details'" />
          </tidy-row>
          @if (!item) {
            <tidy-row>
              <tidy-select
                [icon]="'assets/svg/list.svg'"
                [label]="'Category'"
                [items]="categoryItems"
                [multiple]="false"
                [form]="form.get('category')"
                [submitted]="submitted"
                formControlName="category"
                (optionChange)="selectCategory($event)" />
            </tidy-row>
            @if (showAddressSelect) {
              <tidy-row>
                <tidy-select
                  [icon]="'assets/svg/home.svg'"
                  [label]="'Add to properties'"
                  [form]="form.controls.address"
                  [multiple]="true"
                  formControlName="address"
                  [items]="addressItems"
                  (optionChange)="addRemoveAddress($event)" />
              </tidy-row>
            }
            @if (!showConsumables) {
              <tidy-row>
                <tidy-auto-complete
                  [icon]="'assets/svg/create.svg'"
                  [label]="'Name or Model #'"
                  formControlName="model"
                  [options]="models"
                  [form]="form.controls.model"
                  (action)="selectModel($event)"
                  [submitted]="submitted"
                  [errorMessage]="'Please enter a name or model #'" />
              </tidy-row>
            }
          }
          @if (showConsumables) {
            <tidy-row>
              <tidy-input
                [icon]="'assets/svg/create.svg'"
                [label]="'Name'"
                formControlName="model"
                [form]="form.controls.model"
                [submitted]="submitted"
                [errorMessage]="'Please enter a name'" />
            </tidy-row>
          }
          @if (!selectedModelID) {
            @for (characteristic of characteristics; track characteristic; let index = $index) {
              <tidy-row>
                <tidy-select
                  [icon]="'assets/svg/list.svg'"
                  [label]="('Select ' | translate) + characteristic.name"
                  [form]="form.controls['characteristic_' + index]"
                  [formControlName]="'characteristic_' + index"
                  (optionChange)="selectCharacteristic(characteristic, $event)"
                  [items]="characteristic.formData" />
              </tidy-row>
            }
          }
          @if (!showConsumables) {
            <tidy-row>
              <tidy-select
                [icon]="'assets/svg/calendar.svg'"
                [label]="'Year Installed'"
                [form]="form.controls.installation_date"
                formControlName="installation_date"
                errorMessage="Please enter a valid date."
                [items]="installationDateItems"
                [submitted]="submitted" />
            </tidy-row>
          }
        </tidy-card>

        @if (showConsumables) {
          <tidy-card>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/inventory.svg'"
                class="title-size" />
              <tidy-text
                [header]="'Inventory Settings'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'How do you want to update inventory?'" />
            </tidy-row>
            <tidy-checkbox
              (checkedChange)="updateStrategies('auto')"
              [items]="[
                {
                  viewValue: 'Automatically after each reservation', value: true
                }
              ]"
            [initValue]="strategies.includes('auto')" />
          @if (strategies.includes('auto')) {
            <tidy-row class="extra-top-padding">
              <tidy-input
                [icon]="'assets/svg/create.svg'"
                [label]="'# used per reservation'"
                formControlName="itemsPerReservation"
                [form]="form.controls.itemsPerReservation"
                inputMode="numeric"
                [mask]="'number'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a number'" />
            </tidy-row>
          }
          <tidy-checkbox
            (checkedChange)="updateStrategies('task')"
              [items]="[
                {
                  viewValue: 'Using checklists', value: true
                }
              ]"
          [initValue]="strategies.includes('task')" />
        @if (strategies.includes('task') && isUpdatingToDoListsForms) {
          <tidy-loader />
        }
        @if (strategies.includes('task') && !isUpdatingToDoListsForms) {
          @for (addressId of form.controls.address.value; track addressId) {
            <tidy-row class="extra-top-padding">
              <tidy-text
                [body]="getAddressName(addressId) + (' - Which checklists?' | translate)" />
              @if (toDoListsItems[addressId]?.length === 0) {
                <tidy-error-message
                  [text]="'Please add a checklist for this property.'" />
              }
              @if (toDoListsItems[addressId]?.length > 0) {
                <br>
                  @for (item of toDoListsItems[addressId]; track item) {
                    <tidy-checkbox
                      [items]="[item]"
                      [initValue]="listIsAdded(item.value)"
                      (checkedChange)="updateSelectedToDoLists(item.value, addressId)" />
                    @if (listIsAdded(item.value)) {
                      <div style="margin-left: 25px">
                        @if (toDoListsItems[item.value]?.length === 0) {
                          <tidy-error-message
                            [text]="'Please add a card to this checklist.'" />
                        }
                        @for (room of toDoListsItems[item.value]; track room) {
                          <tidy-checkbox
                            [items]="[room]"
                            [initValue]="roomIsAdded(room.value, item.value)"
                            (checkedChange)="updateSelectedRooms(room.value, item.value)" />
                        }
                      </div>
                    }
                  }
                  @if (didNotSelectRoomError) {
                    <tidy-error-message
                      [text]="'Please select a checklist and card to add the item to'" />
                  }
                }
              </tidy-row>
            }
          }
        </tidy-card>
      }

      @if (showConsumables) {
        <tidy-card>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/restock.svg'"
              class="title-size" />
            <tidy-text
              [header]="'Restocking Settings'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="'When something is below the min level it will generate a task to restock. You can opt to have our concierge do this restocking for you or manage it yourself. If the item is below the warning level, and another restocking for the property is occuring, we will also order those items.'" />
          </tidy-row>
          @if (showConsumables) {
            <div class="four-column-form-row padding-bottom-5">
              <tidy-input
                [icon]="'assets/svg/cube.svg'"
                [label]="'Min'"
                formControlName="minQuantity"
                [form]="form.controls.minQuantity"
                inputMode="numeric"
                [mask]="'integer'"
                [submitted]="submitted" />
              <tidy-input
                [icon]="'assets/svg/cube.svg'"
                [label]="'Warning'"
                formControlName="opportunisticOrderLevel"
                [form]="form.controls.opportunisticOrderLevel"
                inputMode="numeric"
                [mask]="'integer'"
                [submitted]="submitted" />
              <tidy-input
                [icon]="'assets/svg/cube.svg'"
                [label]="'Target'"
                formControlName="maxQuantity"
                [form]="form.controls.maxQuantity"
                inputMode="numeric"
                [mask]="'integer'"
                [submitted]="submitted" />
              <tidy-input
                [icon]="'assets/svg/cube.svg'"
                [label]="'Current'"
                formControlName="currentQuantity"
                [form]="form.controls.currentQuantity"
                inputMode="numeric"
                [mask]="'integer'" />
            </div>
            @if (!form.controls.minQuantity.valid && submitted) {
              <tidy-row>
                <tidy-error-message
                  [text]="'Please enter the minimum quantity'" />
              </tidy-row>
            }
            @if (warningBelowMinError && submitted) {
              <tidy-row>
                <tidy-error-message
                  [text]="'The warning level must be greater than or equal to the min quantity'" />
              </tidy-row>
            }
            @if (targetBelowMinError && submitted) {
              <tidy-row>
                <tidy-error-message
                  [text]="'The target must be greater than or equal to the min quantity'" />
              </tidy-row>
            } @else if (!form.controls.maxQuantity.valid && submitted) {
              <tidy-row>
                <tidy-error-message
                  [text]="'Please enter the target quantity to restock up to'" />
              </tidy-row>
            }
            <div class="two-column-form-row padding-bottom-5">
              <tidy-input
                [icon]="'assets/svg/cash.svg'"
                [label]="'Min Price'"
                formControlName="minRestockingPrice"
                inputMode="numeric"
                [mask]="'currencyMask'"
                [form]="form.controls.minRestockingPrice" />
              <tidy-input
                [icon]="'assets/svg/cash.svg'"
                [label]="'Max Price'"
                formControlName="maxRestockingPrice"
                inputMode="numeric"
                [mask]="'currencyMask'"
                [form]="form.controls.maxRestockingPrice"
                [submitted]="submitted" />
            </div>
            @if (!form.controls.maxRestockingPrice.valid && submitted) {
              <tidy-row>
                <tidy-error-message
                  [text]="'Please enter the max price per pack'" />
              </tidy-row>
            }
            <tidy-row>
              <tidy-select
                [icon]="'assets/svg/time.svg'"
                [label]="'Delivery Timing Preferences'"
                [form]="form.controls.deliveryTimingPreferences"
                formControlName="deliveryTimingPreferences"
                [items]="deliveryTimingPreferenceItems" />
            </tidy-row>
            <tidy-row>
              <tidy-input
                [icon]="'assets/svg/create.svg'"
                [label]="'Restocking Notes'"
                formControlName="restockingNotes"
                [form]="form.controls.restockingNotes" />
            </tidy-row>
            <tidy-row>
              <form [formGroup]="form">
                <tidy-select
                  [icon]="'assets/svg/cart.svg'"
                  [label]="'Where to order'"
                  [items]="whereToOrderItems"
                  [form]="form.controls.whereToOrder"
                  [submitted]="submitted"
                  formControlName="whereToOrder"
                  (optionChange)="selectWhereToOrder($event)" />
              </form>
            </tidy-row>

            @if (form.value.whereToOrder?.value == 'other') {
              <tidy-row>
                <form [formGroup]="form">
                  <tidy-input
                    [icon]="'assets/svg/create.svg'"
                    [label]="'Other'"
                    formControlName="whereToOrderOther"
                    [form]="form.controls.whereToOrderOther"
                    [submitted]="submitted"
                    [errorMessage]="'Please describe where to order'" />
                </form>
              </tidy-row>
            }
            @if (form.value.whereToOrder === 'other') {
              <tidy-row>
                <form [formGroup]="form">
                  <tidy-textarea
                    [icon]="'assets/svg/create.svg'"
                    formControlName="whereToOrderOther"
                    [form]="form.controls.whereToOrderOther"
                    [label]="'Where to order details'" />
                </form>
              </tidy-row>
            }
            @if (form.value.whereToOrder?.startsWith('add:')) {
              <tidy-row>
                <tidy-text
                  [header]="'Add Restocking Integration'" />
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [body]="('Please provide the credentials for ' | translate) + selectedWhereToOrderName + ':'" />
              </tidy-row>
              <tidy-row>
                <form [formGroup]="form">
                  <tidy-input
                    [icon]="'assets/svg/person.svg'"
                    formControlName="conciergeLogin"
                    [form]="form.controls.conciergeLogin"
                    [label]="'Username'"
                    [errorMessage]="'Please enter a username'"
                    [submitted]="submitted" />
                </form>
              </tidy-row>
              <tidy-row>
                <form [formGroup]="form">
                  <tidy-input
                    [icon]="'assets/svg/lock-closed.svg'"
                    formControlName="conciergePassword"
                    [form]="form.controls.conciergePassword"
                    [label]="'Password'"
                    [errorMessage]="'Please enter a password'"
                    type="password"
                    [submitted]="submitted" />
                </form>
              </tidy-row>
              <tidy-row>
                <form [formGroup]="form">
                  <tidy-textarea
                    [icon]="'assets/svg/create.svg'"
                    formControlName="conciergeNotes"
                    [form]="form.controls.conciergeNotes"
                    [label]="'Notes'" />
                </form>
              </tidy-row>
            }
            @if (item && warehousePropertyItems.length > 0) {
              <tidy-row>
                <tidy-select
                  [icon]="'assets/svg/home.svg'"
                  [label]="'Pull inventory from'"
                  [items]="warehousePropertyItems"
                  [form]="form.controls.warehouseProperty"
                  formControlName="warehouseProperty" />
              </tidy-row>
            }
          }
        </tidy-card>
        <tidy-restocking-brand-waterfall
          [brands]="preferredBrands"
          [submitted]="submitted"
          (brandsChange)="onPreferredBrandsChange($event)" />
        @if (!photoURL) {
          <tidy-row [align]="'center'">
            <tidy-text
              class="link"
              [body]="'Add Photo'"
              (action)="addImage()" />
          </tidy-row>
        }
        @if (photoURL) {
          <tidy-row class="extra-top-padding">
            <img [src]="photoURL" />
          </tidy-row>
          <tidy-row [align]="'center'">
            <tidy-text
              class="link red"
              [body]="'Remove Photo'"
              (action)="removeImage()" />
          </tidy-row>
        }
      }

      @if (category?.image) {
        <tidy-row [align]="'center'" class="extra-bottom-padding">
          <tidy-image
            [src]="category?.image"
            style="width:30%" />
        </tidy-row>
      }

      <tidy-button
        [text]="item ? (showConsumables ? ('Update Item' | translate) : ('Update Asset' | translate)) : (showConsumables ? ('Add Item' | translate) : ('Add Asset' | translate))"
        [action]="boundAddItem"
        class="primary" />

      @if (hasFormErrors) {
        <tidy-row [align]="'center'">
          <tidy-error-message
            [text]="'There are errors in the fields above. Please scroll up to fix them.'" />
        </tidy-row>
      }

      @if (errorMessage) {
        <tidy-row [align]="'center'">
          <tidy-error-message
            [text]="errorMessage" />
        </tidy-row>
      }

    }
  </tidy-wrapper>
</form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}